// Delegated accordion toggle with animated max-height.
//
// transitionend guard: an interrupted max-height animation fires transitioncancel,
// NOT transitionend, so a `once` end-handler stays attached and runs at the end of
// the NEXT animation instead. A quick close→reopen then hid the freshly opened panel
// (the stale close handler fired on the open transition's end). Every panel therefore
// tracks its pending end-handler, each new animation detaches the previous one, and
// the handlers re-check the item's active state so a stale fire can never flip the
// panel the wrong way. External code that sets maxHeight directly (pdp-reviews resync,
// the resize listener below) cancels transitions the same way — covered by the same
// detach-on-next-start.

function accDetachPending(content) {
  if (content.accPendingEnd) {
    content.removeEventListener('transitionend', content.accPendingEnd);
    content.accPendingEnd = null;
  }
}

function accAnimateClose(item, content, trigger) {
  accDetachPending(content);
  // Start from the current rendered height so closing mid-open continues from where
  // it is instead of jumping to full height first.
  const current = getComputedStyle(content).maxHeight;
  content.style.maxHeight = current === 'none' ? content.scrollHeight + 'px' : current;
  requestAnimationFrame(() => {
    content.style.maxHeight = '0px';
  });
  function handleClose(ev) {
    if (ev.propertyName !== 'max-height') return;
    accDetachPending(content);
    if (item.classList.contains('active')) return;
    content.hidden = true;
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = null;
  }
  content.accPendingEnd = handleClose;
  content.addEventListener('transitionend', handleClose);
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
}

function accAnimateOpen(item, content, trigger) {
  accDetachPending(content);
  content.hidden = false;
  content.setAttribute('aria-hidden', 'false');
  // Start from the current height (0 when fully closed) so reopening mid-close
  // continues from where it is instead of snapping shut first.
  const current = getComputedStyle(content).maxHeight;
  content.style.maxHeight = current === 'none' ? '0px' : current;
  const fullHeight = content.scrollHeight + 'px';
  requestAnimationFrame(() => {
    content.style.maxHeight = fullHeight;
  });
  function handleOpen(ev) {
    if (ev.propertyName !== 'max-height') return;
    accDetachPending(content);
    if (!item.classList.contains('active')) return;
    // after animation, allow auto height so long text isn't cut
    content.style.maxHeight = 'none';
  }
  content.accPendingEnd = handleOpen;
  content.addEventListener('transitionend', handleOpen);
  if (trigger) trigger.setAttribute('aria-expanded', 'true');
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-acc-trigger]');
  if (!trigger) return;

  const item = trigger.closest('[data-acc-item]');
  const group = trigger.closest('[data-acc-group]');
  if (!item || !group) return;

  // Luk alle andre i samme gruppe
  group.querySelectorAll('[data-acc-item].active').forEach(el => {
    if (el !== item) {
      el.classList.remove('active');
      const content = el.querySelector('[data-acc-content]');
      if (content) accAnimateClose(el, content, el.querySelector('[data-acc-trigger]'));
    }
  });

  // Toggle denne
  item.classList.toggle('active');
  const content = item.querySelector('[data-acc-content]');
  if (item.classList.contains('active')) {
    accAnimateOpen(item, content, trigger);
  } else {
    accAnimateClose(item, content, trigger);
  }
});

// Recalculate height for active items on resize (e.g., font reflow, viewport changes)
window.addEventListener('resize', () => {
  document.querySelectorAll('[data-acc-item].active [data-acc-content]').forEach(content => {
    if (content.hidden) return;
    content.style.maxHeight = 'none';
  });
});
